/**
 *
 * provides an acequia object
 *
 */

import {
    acequiaStore,
    acequiaReady,
    activeGroups,
    getUserId,
    getDeviceId,
    getInstanceId,
    getHandle,
    getDeviceName,
    getInstanceName,
    getKeys,
    getUserKeys,
    getDiscoveryOrigin,
    postToSW,
    swControlled,
    serviceWorkerStatus,
    routes,
    checkLocalNetworkAccessPermission,
    requestLocalNetworkAccess,
    refreshUserIdentity,
    diagnoseRoutes,
} from './acequia/acequia.js'

import utils from './acequia/utils.js'

import * as webrtc from './acequia/webrtc/webrtc.js'
import { config } from './config.js'

// Build version — updated by build script
export const ACEQUIA_BUILD = '__ACEQUIA_BUILD_TIMESTAMP__'

import * as auth from './auth/auth.js'
import * as groups from './acequia/groups.js'
import * as tokens from './auth/tokens.js'
import * as deviceLink from './auth/deviceLink.js'
import * as chains from './auth/chains.js'
import * as revocations from './auth/revocations.js'
import * as grants from './auth/grants.js'
import * as identities from './auth/identities.js'
import * as viewerIdentity from './auth/viewerIdentity.js'
import { createGrantManager, GrantManager } from './auth/grantManager.js'
import { createGrantClient, GrantClient } from './auth/grantClient.js'
import * as storage from './acequia/storageWatchdog.js'
import * as envelopes from './auth/envelopes.js'
import * as cookies from './auth/cookies.js'
import * as contentAddressed from './auth/contentAddressed.js'
import * as swRegistry from './acequia/swRegistry.js'
import * as swMounts from './acequia/swMounts.js'
import * as swLocalMount from './acequia/swLocalMount.js'
import * as datasources from './acequia/datasources.js'
import * as swMountProxy from './acequia/swMountProxy.js'
import * as swRedeem from './acequia/swRedeem.js'
import * as swSweep from './acequia/swSweep.js'
import * as swExternalCache from './acequia/swExternalCache.js'
import * as swHtmx from './acequia/swHtmx.js'
import * as localDispatch from './acequia/localDispatch.js'
import * as peerTokens from './auth/peerTokens.js'
import * as routeAuth from './acequia/routeAuth.js'
import * as tokenProtocol from './auth/tokenProtocol.js'

import * as webdav from './acequia/webdav.js'
import * as browserdav from './acequia/browserdav/index.js'
import * as sync from './acequia/sync/index.js'

// add acequia to window
try {
    if (typeof window !== 'undefined') {
        console.log(`[acequia] build: ${ACEQUIA_BUILD}`)
        window.acequia = {
            ACEQUIA_BUILD,
            acequiaReady,
            acequiaStore,
            activeGroups,
            auth,
            chains,
            config,
            contentAddressed,
            cookies,
            envelopes,
            grants,
            createGrantManager,
            GrantManager,
            createGrantClient,
            GrantClient,
            storage,
            identities,
            viewerIdentity,
            peerTokens,
            revocations,
            routeAuth,
            tokenProtocol,
            deviceLink,
            diagnoseRoutes,
            getDiscoveryOrigin,
            getUserId,
            getDeviceId,
            getInstanceId,
            getHandle,
            getDeviceName,
            getInstanceName,
            getKeys,
            getUserKeys,
            groups,
            tokens,
            webrtc,
            utils,
            webdav,
            browserdav,
            sync,
            postToSW,
            swControlled,
            serviceWorkerStatus,
            routes,
            swRegistry,
            swMounts,
            swLocalMount,
            datasources,
            swMountProxy,
            swRedeem,
            swSweep,
            swExternalCache,
            swHtmx,
            localDispatch,
            checkLocalNetworkAccessPermission,
            requestLocalNetworkAccess,
            refreshUserIdentity,
        }

        // Passive session-cookie maintenance on any page that loads the
        // library (token-cookie-security §2/§3). Off the critical path;
        // a no-op without an existing cookie (so it never creates an
        // identity), and the replacement cookie is only written after it
        // authenticates against this server — local keys/ids do not
        // imply registration.
        if (typeof document !== 'undefined') {
            setTimeout(() => {
                cookies.checkAuthCookieRenewal().catch(() => {})
            }, 3000)
        }
    }
} catch (e) {
    console.error('Got Error: ', e)
}

export default {
    acequiaReady,
    acequiaStore,
    auth,
    chains,
    config,
    contentAddressed,
    cookies,
    deviceLink,
    envelopes,
    diagnoseRoutes,
    getDiscoveryOrigin,
    getUserId,
    getDeviceId,
    getInstanceId,
    getHandle,
    getDeviceName,
    getInstanceName,
    getKeys,
    getUserKeys,
    grants,
    createGrantManager,
    GrantManager,
    createGrantClient,
    GrantClient,
    storage,
    groups,
    identities,
    viewerIdentity,
    peerTokens,
    revocations,
    routeAuth,
    tokenProtocol,
    tokens,
    webrtc,
    utils,
    webdav,
    browserdav,
    sync,
    postToSW,
    swControlled,
    serviceWorkerStatus,
    routes,
    swRegistry,
    swMounts,
    swLocalMount,
    datasources,
    swMountProxy,
    swRedeem,
    swSweep,
    swExternalCache,
    swHtmx,
    localDispatch,
    checkLocalNetworkAccessPermission,
    requestLocalNetworkAccess,
    refreshUserIdentity,
}
